<template>
  <div class="card-html">
    <div class="cate-item-head">
      <div class="Card-box -intro-x" v-if="isPop">
        <div class="card-item cardClass" @click="getCardIiem('续费应用')">
          续费应用
        </div>
        <div class="card-item cardClass" @click="getCardIiem('增加功能')">
          增加功能
        </div>
        <div class="card-item cardClass" @click="getCardIiem('升级')">升级</div>
        <div class="card-item cardClass" @click="getCardIiem('编辑')">编辑</div>
      </div>

      <div
        class="item-appName"
        :style="'background:' + item.color"
        v-if="!item.icon"
      >
        {{ item.name[0].substring(0, 1) || "未" }}
      </div>

      <img :src="item.icon" class="item-appName" v-else alt="" />

      <div
        class="item-cardRihgt"
        @click="onIconShow(index)"
        :id="'more-oprate' + index"
      >
        <i class="el-icon-more" style="font-size: 20px; color: #bbc6da"></i>
      </div>
    </div>
    <div class="item-name">{{ item.name[0] || "未命名应用" }}</div>
    <div class="itemMainName">{{ item.app_name }}</div>
    <div class="item-platform-box">
      <div v-for="(img, list) in item.platform" :key="list">
        <img class="platForm-img" :src="platImg(img)" alt="" />
      </div>
    </div>

    <div class="item-content">
      <div style="color: #999999">运营模式</div>
      <div style="color: #333333">
        {{ item.pay_mode === "0" ? "授信模式" : "支付模式" }}
      </div>
    </div>

    <div class="item-content">
      <div style="color: #999999">创建时间</div>
      <div style="color: #333333">{{ item.create_time }}</div>
    </div>
    <div class="item-content">
      <div style="color: #999999">到期时间</div>
      <div style="color: #333333">{{ item.expire }}</div>
    </div>
    <div class="item-button" @click="onDetali(item)">查看详情</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isPop: false,
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => {},
    },
  },
  computed: {
    platImg() {
      return function (value) {
        if (value === "android") {
          return require("../assets/images/anzhuo.png");
        }
        if (value === "ios") {
          return require("../assets/images/ios.png");
        }
        if (value === "applet") {
          return require("../assets/images/applet.png");
        }
        if (value === "web") {
          return require("../assets/images/h5.png");
        }
      };
    },
  },
  created() {
    // console.log("appdetails created = " + JSON.stringify(this.CardData))
    // 点击其他位置关闭弹窗
    document.addEventListener("mouseup", (e) => {
      var _con = document.getElementById("more-oprate" + this.index);
      if (_con) {
        if (!_con.contains(e.target)) {
          this.isPop = false;
        }
      }
    });
    this.$forceUpdate();
  },

  methods: {
    // 查看应用详情
    onDetali: function (data) {
      // , query: data
      this.$router.push({ path: "terminal", query: data });
    },
    onIconShow: function () {
      this.isPop =  true
    },

    getCardIiem: function (data) {
      this.$message.info("暂无开通");
      return;
    },
  },
};
</script>
<style lang="scss" scoped>
.cate-item-head {
  display: flex;
  justify-content: space-between;
  .item-appName {
    width: 74px;
    height: 74px;
    background: #6fa5b1;
    opacity: 1;
    border-radius: 20px;
    text-align: center;
    line-height: 74px;
    color: #fff;
    font-size: 32px;
  }
  .item-cardRihgt {
    width: 32px;
    height: 32px;
    display: flex;
    border: 1px solid #bbc6da;
    border-radius: 50%;
    opacity: 1;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .item-cardRihgt:hover {
    border: 1px solid #1890ff;
    .el-icon-more {
      color: #1890ff !important;
    }
  }
}
.item-name {
  color: #333333;
  font-size: 26px;
  line-height: 35px;
  margin: 14px 0 0px;
}
.itemMainName {
  color: #999999;
  font-size: 16px;
  margin-bottom: 24px;
  line-height: 16px;
}
.item-platform-box {
  display: flex;
  padding-bottom: 16px;
  margin-bottom: 14px;
  border-bottom: 1px solid #e8e8eb;
  .platForm-img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}

.item-content {
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.item-button {
  width: 100%;
  height: 56px;
  background: #f7f7fa;
  opacity: 1;
  border-radius: 16px;
  color: #8f9cc6;
  text-align: center;
  line-height: 56px;
  font-size: 16px;
  margin-top: 15px;
  cursor: pointer;
}

.item-button:hover {
  box-shadow: 0px 0px 10px rgba(24, 144, 250, 0.3);
  background: #1890fa;
  color: #fff;
  transition: box-shadow 0.3s, background-color 0.3s, color 0.3s;
}

.Card-box {
  position: absolute;
  width: 200px;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  right: 15px;
  top: 34px;
}
.card-item {
  line-height: 46px;
  height: 46px;
  width: 100%;
  text-indent: 16px;
  font-size: 14;
  color: #bbc6da;
  cursor: pointer;
}

.cardClass:hover {
  background: #f7f8fb;
  color: #1890ff;
}

.card-html {
  position: relative;
}





</style>